import React, {Component} from 'react'
import { Row, Col } from 'reactstrap';
import PropTypes from "prop-types";

export default class StepLayout extends Component {
    render() {
        
        // const Router = process.env.REACT_APP_IPFS === 'True' ? HashRouter : BrowserRouter
        return (
            <>
            <Row>
            <Col>
            <h2 className="display-2 text-black" style={{
            background: '-webkit-linear-gradient(top right,  #6EA59A, #867fd7)',
            webkitBackgroundClip: 'text',
            webkitTextFillColor: 'transparent',
            fontSize: '25px'
          }}>{this.props.title}</h2>
            <img src={this.props.img} width="700px" height="425px" />
            </Col>
            <Col>
            <div className="d-flex px-3" style={{ backgroundColor: "#fcf5f9", width: "300px", borderRadius: "10px", margin: "35px 0 0 0", height:"425px" }}>
                    <div>
                      <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                        <i className="ni ni-building text-primary" />
                      </div>
                    </div>
                      <p className="lead text-muted" style={{fontSize: '16px'}}>
                        <br/>
                       {this.props.description}
                       <br/>
                      </p>
                  </div>
            </Col>
          </Row>
          <br></br>
          </>
        )
    }
}

StepLayout.propTypes = {
    img: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};
